import { render, staticRenderFns } from "./ResMng.vue?vue&type=template&id=729fb4fa&scoped=true&"
import script from "./ResMng.vue?vue&type=script&lang=js&"
export * from "./ResMng.vue?vue&type=script&lang=js&"
import style0 from "./ResMng.vue?vue&type=style&index=0&id=729fb4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729fb4fa",
  null
  
)

export default component.exports